import './Scoreboard.css';
import TimingClock from '../../components/TimingClock';
import Bulbs from '../../components/Bulbs';
import {
  liftsSelector,
  eventsSelector,
  protocolsSelector,
  resultsSelector,
} from '../../orm/selectors';
import { computeCallingOrder } from '../../rules/callingOrder';
import { formatName } from '../../common';

import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import { createSelector } from 'reselect';
import {
  find,
  findIndex,
  filter,
  flatMap,
  get,
  map,
  maxBy,
  pick,
  range,
  uniq,
} from 'lodash';

const LiftCell = ({ row, lift, number, meta }) => {
  // TODO: Consolidate with ProtocolDownloads! From
  const declaration = maxBy(
    filter(get(row.athlete, ['declarationsByLiftId', lift.id], []), {
      attemptNumber: number,
    }),
    'changeNumber',
  );
  const attempt = find(get(row.athlete, ['attemptsByLiftId', lift.id]), {
    number,
  });
  const result = get(row, ['resultsByLiftId', lift.id]);

  let className = 'empty';
  let content = '';
  // FIXME: decision check should not be needed?
  if (attempt && attempt.decision) {
    const { weight, decision } = attempt;

    [className, content] = decision.isGoodLift
      ? ['good lift', <u>{weight}</u>]
      : ['no lift', <s>{weight}</s>];
  } else if (declaration) {
    [className, content] = ['declared', `'${declaration.weight}`];
  } else if (result !== undefined) {
    [className, content] = ['omitted', '---'];
  }

  // FIXME: Propagate to protocol.
  if (lift.id === meta.currentLift.id) className = `${className} current lift`;

  return <td className={`${className} attempt cell`}>{content}</td>;
};

const ResultCell = ({ row, lift }) => {
  //const result = get(row, ['resultsByLiftId', lift.id]);
  // FIXME: This differs from protocol.
  const result = get(
    row.athlete,
    ['bestAttemptByLiftId', lift.id, 'weight'],
    0,
  );
  const content = <strong>{result === 0 ? '---' : result}</strong>;

  return <td className="result attempt cell">{content}</td>;
};

const LiftCells = ({ row, lift, meta }) => (
  <Fragment>
    {range(1, lift.attemptCount + 1).map(number => (
      <LiftCell
        key={number}
        row={row}
        lift={lift}
        number={number}
        meta={meta}
      />
    ))}
    <ResultCell row={row} lift={lift} />
    <td className="spacer cell" />
  </Fragment>
);

LiftCells.Header = ({ lift }) => (
  <Fragment>
    {range(1, lift.attemptCount + 1).map(number => (
      <td key={number} />
    ))}
  </Fragment>
);

const TotalCells = ({ row }) => {
  const total = get(row, 'total');
  const content = <strong>{total === 0 ? '---' : total}</strong>;
  return <td className="total cell">{content}</td>;
};

const ScoreboardHeader = ({ meta }) => (
  <thead>
    <tr>
      <th />
      <th colSpan={5} />
      <th className="spacer cell" />
      <th colSpan={4}>SNATCH</th>
      <th className="spacer cell" />
      <th colSpan={4}>CLEAN and JERK</th>
      <th className="spacer cell" />
      <th>&nbsp;</th>
    </tr>
    <tr>
      <th />
      <th>NAME</th>
      <th>BORN</th>
      <th>TEAM</th>
      <th>AGE GROUP</th>
      <th>CATEGORY</th>
      <th />
      <th>1</th>
      <th>2</th>
      <th>3</th>
      <th>=</th>
      <th />
      <th>1</th>
      <th>2</th>
      <th>3</th>
      <th>=</th>
      <th />
      <th>TOTAL</th>
    </tr>
  </thead>
);

const ScoreboardRow = ({ row, callingOrder, meta }) => {
  const classNames = {
    [-1]: 'finished',
    0: 'current',
    1: 'next',
  };
  return (
    <tr className={`${classNames[callingOrder]} athlete row`}>
      <td className="start-number cell">{row.athlete.startNumber}</td>
      <td className="name cell">{formatName(row.athlete.entry)}</td>
      <td>{row.yearOfBirth}</td>
      <td>{row.teams.join(', ')}</td>
      <td>{row.ageGroups.join(', ')}</td>
      <td>{row.categories.join(', ')}</td>
      <td className="spacer cell" />
      {meta.orm.lifts.map(lift => (
        <LiftCells key={lift.id} row={row} lift={lift} meta={meta} />
      ))}
      <TotalCells row={row} />
    </tr>
  );
};

const ScoreboardDividerRow = () => (
  <tr className="divider row">
    <td colSpan={12} />
  </tr>
);

class Scoreboard extends Component {
  state = { blink: false };

  blink = () => {
    this.setState(state => ({ blink: !state.blink }));
  };

  componentDidMount() {
    this.blinkInterval = window.setInterval(this.blink, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.blinkInterval);
  }

  render() {
    const { protocol, lift, callingOrder, timingClock, orm } = this.props;
    const meta = { orm, currentLift: lift };
    let previousCategory;
    const { blink } = this.state;
    const className = blink ? 'blink' : '';
    return (
      <main className="nosturi scoreboard page">
        <Bulbs />
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            marginRight: '2rem',
            marginTop: '2rem',
          }}
        >
          <TimingClock {...timingClock} size="big" />
        </div>
        {protocol && (
          <Fragment>
            <h1>{protocol.title}</h1>
            <table className={`nosturi scoreboard table ${className}`}>
              <ScoreboardHeader meta={meta} />
              <tbody>
                {flatMap(protocol.rows, (row, index) => {
                  const dividerRow =
                    index && row.category !== previousCategory ? (
                      <ScoreboardDividerRow />
                    ) : (
                      undefined
                    );
                  previousCategory = row.category;
                  return (
                    <Fragment key={row.key}>
                      {dividerRow}
                      <ScoreboardRow
                        row={row}
                        callingOrder={findIndex(
                          callingOrder,
                          pick(row.athlete, 'primaryKey'),
                        )}
                        meta={meta}
                      />
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </Fragment>
        )}
      </main>
    );
  }
}

Scoreboard.slug = 'scoreboard';
Scoreboard.title = 'Scoreboard';

const mapStateToProps = () => {
  const callingOrderSelector = createSelector(
    ({ protocol }) => get(protocol, 'athletes', []),
    ({ lift }) => get(lift, 'id', -1),
    ({ event }) => get(event, 'mode', 'default'),
    (athletes, liftId, mode) => {
      if (!athletes.length || liftId === -1) return [];
      return computeCallingOrder(athletes, liftId, mode);
    },
  );

  return ({ venue, orm }) => {
    const lifts = liftsSelector(orm);
    const events = eventsSelector(orm);
    const protocols = protocolsSelector(orm);
    const [currentEvent] = events;

    const currentProtocol = find(protocols, [
      'uuid',
      get(venue.competition, 'current.protocol'),
    ]);
    const currentLift = find(lifts, [
      'uuid',
      get(venue.competition, 'current.lift'),
    ]);

    const callingOrder = callingOrderSelector({
      protocol: currentProtocol,
      lift: currentLift,
      event: currentEvent,
    });

    const meta = { lifts };

    const rows = map(get(currentProtocol, 'athletes'), athlete => {
      const { contests } = athlete.entry;

      const ageGroups = uniq(map(contests, 'ageGroup.abbreviation'));
      const categories = uniq(map(contests, 'bodyweightCategory.abbreviation'));
      const category = categories[0];
      const yearOfBirth = get(athlete, 'entry.dateOfBirth', '').substr(0, 4);
      const teams = map(get(athlete, 'entry.teams'), 'abbreviation');

      return {
        key: athlete.id,
        athlete,
        ageGroups,
        categories,
        category,
        yearOfBirth,
        teams,
        ...resultsSelector(athlete, meta),
      };
    });

    return {
      protocol: currentProtocol && {
        ...currentProtocol,
        rows,
      },
      lift: currentLift,
      callingOrder,
      ...pick(venue.competition, 'timingClock'),
      orm: {
        lifts,
        protocols,
      },
    };
  };
};

export default connect(mapStateToProps)(Scoreboard);



// WEBPACK FOOTER //
// ./src/displays/Scoreboard/Scoreboard.js